import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

export const textFieldStyles = style({
  marginTop: '16px',
  width: '100%'
});

export const dataGridContainerStyle = style({
  borderBottom: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.L6)}`,
  marginBottom: '16px'
});

export const siteRolePickerTopMargin = style({
    marginTop: '16px'
  });

export const dataGridStyle: React.CSSProperties = {
  overflow: 'hidden',
  padding: '0px',
  marginTop: `${CommonStyles.Sizes.LineHeight}px`,
  zIndex: 'auto',
  height: 305
};

export const dataGridRowHeight = 32;
